import { colors } from '@/utils/helpers'
import i18n from '@/plugins/i18n'

export enum Character {
  OVERSTRAIN = 'overstrain',
  TRAUMA = 'trauma',
  HEALTH_ISSUES = 'health_issues'
}

export const CharacterList = {
  [Character.OVERSTRAIN]: {
    get text() { return i18n.t('character.overstrain') }
  },
  [Character.TRAUMA]: {
    get text() { return i18n.t('character.trauma') }
  },
  [Character.HEALTH_ISSUES]: {
    get text() { return i18n.t('character.health_issues') }
  }
}

export enum Contact {
  ANOTHER_PLAYER = 'another_player',
  BALL_OBJECT = 'ball_object',
  OTHER = 'other',
}

export const ContactList = {
  [Contact.ANOTHER_PLAYER]: {
    get text() { return i18n.t('contact.another_player') }
  },
  [Contact.BALL_OBJECT]: {
    get text() { return i18n.t('contact.ball_object') }
  },
  [Contact.OTHER]: {
    get text() { return i18n.t('contact.other') }
  }
}

export enum Mechanism {
  SPRINT = 'sprint',
  IMPACT = 'impact',
  CHANGE_DIRECTION = 'change_direction',
  ACCELERATION = 'acceleration',
  DECELERATION = 'deceleration',
  JUMP = 'jump',
  SHOOTING_PASSING = 'shooting_passing',
  RESISTANCE_TRAINING = 'resistance_training',
}

export const MechanismList = {
  [Mechanism.SPRINT]: {
    get text() { return i18n.t('mechanism.sprint') }
  },
  [Mechanism.IMPACT]: {
    get text() { return i18n.t('mechanism.impact') }
  },
  [Mechanism.CHANGE_DIRECTION]: {
    get text() { return i18n.t('mechanism.direction_change') }
  },
  [Mechanism.ACCELERATION]: {
    get text() { return i18n.t('mechanism.acceleration') }
  },
  [Mechanism.DECELERATION]: {
    get text() { return i18n.t('mechanism.deceleration') }
  },
  [Mechanism.JUMP]: {
    get text() { return i18n.t('mechanism.jump') }
  },
  [Mechanism.SHOOTING_PASSING]: {
    get text() { return i18n.t('mechanism.shooting_passing') }
  },
  [Mechanism.RESISTANCE_TRAINING]: {
    get text() { return i18n.t('mechanism.resistance_training') }
  }
}

export enum InjuryPhase {
  INJURY = 'injury',
  DIAGNOSIS = 'diagnosis',
  REHABILITATION = 'rehabilitation',
  RETURN_TRAINING = 'training',
  RETURN_COMPETITION = 'competition',
}

export const InjuryPhases = {
  [InjuryPhase.INJURY]: {
    get text() { return i18n.t('injury_individual.status.injury') },
    color: colors[0]
  },
  [InjuryPhase.DIAGNOSIS]: {
    get text() { return i18n.t('status.injury_status.diagnosis') },
    color: colors[2]
  },
  [InjuryPhase.REHABILITATION]: {
    get text() { return i18n.t('injury_individual.status.rehabilitation') },
    color: colors[3]
  },
  [InjuryPhase.RETURN_TRAINING]: {
    get text() { return i18n.t('injury_individual.status.return_to_training') },
    color: colors[7]
  },
  [InjuryPhase.RETURN_COMPETITION]: {
    get text() { return i18n.t('injury_individual.status.return_to_competition') },
    color: colors[9]
  }
}
